var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrap"},[_c('topbar',{staticClass:"topbar-wrap"}),_c('sidebar',{staticClass:"sidebar-wrap"}),_c('page-main',{staticClass:"page-main"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }